export default __webpack_public_path__ + "images/40dc7e70bdaf1e1ae8add5e9f0df016e.png";